import { Grid } from "capitalrx-components-2.0/lib/layout";
import { Image } from "capitalrx-components-2.0/lib/general";

import ErrorMessageBody from "./ErrorMessageBody";
import ErrorRover from "./images/error-rover.svg?url";

import styles from "./Error.module.scss";

interface Props {
  type?: "reject";
}

const ErrorSection = ({ type }: Props): JSX.Element => {
  return (
    <div className={styles.ErrorContainer}>
      <Grid className={styles.Error}>
        <Grid.Span columns={6}>
          <ErrorMessageBody type={type} />
        </Grid.Span>
        <Grid.Span columns={6}>
          <div className={styles.ErrorImage}>
            <Image src={ErrorRover} alt="Error Image" />
          </div>
        </Grid.Span>
      </Grid>
    </div>
  );
};

export default ErrorSection;
